<template>
  <div>
    <div id="qrcode-container"></div>
    <button @click="checkLoginStatus">检查登录状态</button>
  </div>
</template>

<script>
export default {
    mounted() {
        this.loadSDK();
    },
    methods: {
        loadSDK() {
            const script = document.createElement('script');
            script.src = 'https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js';
            script.onload = this.initSDK;
            document.body.appendChild(script);
        },
        initSDK() {
            const obj = new WxLogin({
                self_redirect: false,
                id: "qrcode-container",
                appid: "wx44bb3fd01c732b33",
                scope: "snsapi_login",
                redirect_uri: "http%3A%2F%2Fred.lijiantek.com%3A8880%2F%23%2FModelTotal",
                state: "STATE#wechat_redirect",
                style: "",
                href: ""
            });
        },
        checkLoginStatus() {
            // 发送请求检查登录状态
            axios.get('/api/checkLoginStatus')
            .then(response => {
            // 处理登录状态检查结果
            })
            .catch(error => {
            // 处理异常情况
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/WxLogin.vue